import React, { useEffect, useMemo, useRef, useState } from 'react';
import { upperFirst } from 'lodash';
import { Modal } from 'react-bootstrap';
import { Formik, Form as FormikForm } from 'formik';
import { t } from 'i18next';
import { useDispatch, useSelector } from 'react-redux';
import { commaSeparatedTemplateTypes } from './hook';
import Complaints from '../../patient/visits/form/complaints';
import RxComponent from '../../patient/visits/form/rx';
import Diagnosis from '../../patient/visits/form/diagnosis';
import { setTemplateInitialValues, templateInitialValues } from './composables';
import { setTemplatesDetails } from '../../../redux/template/slice';


const TemplateItemsModel = ({ show, close, type, title, search = '' }) => {
	const [initialValues, setInitialValues] = useState(templateInitialValues);
	const { details } = useSelector(state => state.templates);
	const isEdit = useMemo(() => Boolean(details?.id), [details]);
	const formRef = useRef(null);
	const dispatch = useDispatch();

	const handleClose = () => {
		setInitialValues(templateInitialValues);
		formRef.current.resetForm();
		dispatch(setTemplatesDetails(null));
		close();
	};

	const getModelTitle = useMemo(() => {
		if (commaSeparatedTemplateTypes.includes(type) && !isEdit) {
			return t('ALLOPATHY.ADD_BUTTON', { type: upperFirst(title) });
		} else {
			return t('ALLOPATHY.UPDATE_BUTTON', { type: upperFirst(title) });
		}
	}, [type, title, isEdit, t]);

	useEffect(() => {
		if (details && details.id) {
			setInitialValues(setTemplateInitialValues(type, details));
		} else {
			setInitialValues(templateInitialValues);
		}
	}, [details]);

	return (
		<Modal show={show} onHide={handleClose} backdrop="static" centered size='xl' >
			<Modal.Header closeButton>
				<Modal.Title>{getModelTitle}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Formik
					innerRef={formRef}
					initialValues={initialValues}
					enableReinitialize={true}
					id="visit-form">
					{() => {
						return (
							<FormikForm>
								{type === 'complaint' && <Complaints isHideIcons={true} customTitle={''} onClose={handleClose} isFromSettings={true} search={search} />}
								{type === 'diagnosis' && <Diagnosis isHideIcons={true} customTitle={''} onClose={handleClose} isFromSettings={true} search={search} />}
								{type === 'prescription' && <RxComponent isHideIcons={true} customTitle={''} onClose={handleClose} isFromSettings={true} search={search} />}
							</FormikForm>
						);
					}}
				</Formik>
			</Modal.Body>
		</Modal >
	);
};

export default TemplateItemsModel;